import theme from '@ifca-root/react-component/src/assets/theme';
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import useUploadAttachment from '@ifca-root/react-component/src/utils/hooks/useUploadAttachment';
import {
	Checkbox,
	FormControl,
	Grid,
	MenuItem,
	RadioGroup,
	TextField,
	Typography,
	useMediaQuery,
} from '@material-ui/core';
import { OfflineTerminalDialog } from 'components/Dialog/OfflineTerminalDialog';
import {
	applyTerminalResultToPaymentForm,
	getSelectedCreditPaymentAmount,
	mergeTerminalResultIntoFormData,
	shouldUseOfflineTerminalForPayment,
} from 'helpers/offlineTerminal/applyTerminalResultToPaymentForm';
import { isCreditPaymentWaitingForDebtorList } from 'helpers/offlineTerminal/resolvePaymentCreditCardType';
import { buildEcrPayRequest } from 'helpers/offlineTerminal/getOutletEcrTerminal';
import type { OfflineTerminalDialogState } from 'helpers/offlineTerminal/offlineTerminalTypes';
import {
	inquiryTerminalTransaction,
	payOnTerminal,
} from 'services/ecrAgent';
import { SearchField } from 'components/Dialog/SearchDialogComponent';
import { LHDNconfirmationDialog } from 'containers/OutletModule/HomeNew/Payment/LHDNCustomDialog';
import {
	CreditCardType,
	PaymentClass,
	useGetbuyerInfoLazyQuery,
	useGetMenuXDebtorListLazyQuery,
	useGetMenuXInhouseListQuery,
	useGetOfficerLazyQuery,
	useGetRoundingPolicyLazyQuery,
	useGetStaffLazyQuery,
} from 'generated/graphql';
import { useFuseSearch } from 'helpers/hooks/useSearch';
import { amtStr } from 'helpers/numFormatter';
import React, { useEffect, useRef, useState } from 'react';
import { Controller } from 'react-hook-form';
import NumberFormat from 'react-number-format';
import SignatureCanvas from 'react-signature-canvas';

export const RetailPaymentDialog = (props: any) => {
	const {
		state,
		dispatch,
		handleSubmit,
		currencyCode,
		total,
		register,
		setValue,
		watch,
		reset,
		integrateCityLedger,
		hotelID,
		control,
		defaultRoom,
		setDefaultRoom,
		defaultNonGuest,
		setDefaultNonGuest,
		defaultFolio,
		setDefaultFolio,
		defaultDebtor,
		setDefaultDebtor,
		defaultOfficer,
		setDefaultOfficer,
		defaultStaff,
		setDefaultStaff,
		selectedOfficer,
		selectedStaff,
		setSelectedOfficer,
		setSelectedStaff,
		selectedDebtor,
		setSelectedDebtor,
		selectedOrder,
		selectedRoom,
		setSelectedRoom,
		selectedNonGuest,
		setSelectedNonGuest,
		selectedFolio,
		setSelectedFolio,
		selectedCredit,
		setSelectedCredit,
		loading1,
		loading2,
		getDefaultPayment,
		onSubmit,
		subtotal,
		discount,
		rounding,
		locked,
		setLocked,
		setLocked2,
		outletID,
		tableID,
		orderID,
		setSelectedPaymentsign,
		outlet,
		billID,
		enableOfflineTerminal = false,
		cardBizEcrList = [],
		transactionId,
		onEcrPaymentApproved,
	} = props;

	const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});

		const EinvoiceCheck =
		outlet?.company?.isEInvIntegrated === true &&
		new Date(outlet?.businessDate) >=
			new Date(outlet?.company?.eInvStartDate) &&
		new Date(outlet?.businessDate) <= new Date(outlet?.company?.eInvEndDate);

		const [openExitDialog, setOpenExitDialog] = useState(false);
		const [filesLHDN, setFilesLHDN] = useState(null);
		const [isBuyerDetails, setIsBuyerDetails] = useState(false);
		let [array, setArray] = useState([]);

		const hasSuspendFolioIssue =
				array?.filter(x => x?.paymentClass === PaymentClass.SuspendFolio)?.length >
					0 &&
				Object?.values(selectedFolio ?? {})?.length <= 0 &&
				Object?.values(defaultFolio ?? {})?.length <= 0;
			const hasDebtorIssue =
				array?.filter(x => x?.paymentClass === PaymentClass.Debtor)?.length > 0 &&
				(selectedDebtor?.CreditBalance <= 0 ||
					(Object?.values(selectedDebtor ?? {})?.length <= 0 &&
						Object?.values(defaultDebtor ?? {})?.length <= 0));
			const hasNonGuestIssue =
				array?.filter(x => x?.paymentClass === PaymentClass.NonGuest)?.length > 0 &&
				(selectedNonGuest?.CreditBalance <= 0 ||
					(Object?.values(selectedNonGuest ?? {})?.length <= 0 &&
						Object?.values(defaultNonGuest ?? {})?.length <= 0));
			const hasOfficerIssue =
				array?.filter(x => x?.paymentClass === PaymentClass.Officer)?.length > 0 &&
				Object?.values(selectedOfficer ?? {})?.length <= 0 &&
				Object?.values(defaultOfficer ?? {})?.length <= 0;
			const hasStaffIssue =
				array?.filter(x => x?.paymentClass === PaymentClass.Staff)?.length > 0 &&
				Object?.values(selectedStaff ?? {})?.length <= 0 &&
				Object?.values(defaultStaff ?? {})?.length <= 0;
			const hasRoomIssue =
				array?.filter(x => x?.paymentClass === PaymentClass.Room)?.length > 0 &&
				(selectedRoom?.CreditBalance <= 0 ||
					(Object?.values(selectedRoom ?? {})?.length <= 0 &&
						Object?.values(defaultRoom ?? {})?.length <= 0));
			const hasAnyIssue =
				hasSuspendFolioIssue ||
				hasDebtorIssue ||
				hasNonGuestIssue ||
				hasOfficerIssue ||
				hasStaffIssue ||
				hasRoomIssue;
	const [terminalDialogState, setTerminalDialogState] =
		useState<OfflineTerminalDialogState>('idle');
	const [terminalErrorMessage, setTerminalErrorMessage] = useState('');
	const pendingFormDataRef = useRef<{ data: any; files?: any } | null>(null);

	const sortCounter = useRef(0); // starts from 0

	//STATE
	let [error, setError] = useState(false);
	let [errorMessage, setErrorMessage] = useState('');
	let [isTouch, setIsTouch] = useState(false);
	let [isCancel, setCancel] = useState(false);
	let [selectedPayment, setSelectedPayment] = useState(null);
	let [isRoundingOnce, setIsRoundingOnce] = useState(0);
	let [cashReceivedAmount, setCashReceivedAmount] = useState(0);
	let [cashChangeAmount, setCashChangeAmount] = useState(0);
	let [creditCardAmount, setCreditCardAmount] = useState(0);
	let [voucherAmount, setVoucherAmount] = useState(0);
	let [bankTTAmount, setBankTTAmount] = useState(0);
	let [othersAmount, setOthersAmount] = useState(0);

	// API

	const [
		loadRoundingPolicy,
		{
			called: getRoundingPolicyCalled,
			loading: getRoundingPolicyLoading,
			data: { getRoundingPolicy } = { getRoundingPolicy: [] },
			refetch: chargesRefetch,
		},
	] = useGetRoundingPolicyLazyQuery({
		fetchPolicy: 'network-only',
		onCompleted: ({ getRoundingPolicy }) => {
			dispatch({
				type: 'receivedAmount',
				payload:
					getRoundingPolicy[0]?.inUse === true
						? getRoundedAmt(
								balanceT,
								getRoundingPolicy[0]?.smallestDenomination,
						  )
						: balanceT,
			});
			setValue(
				'receivedAmount',
				getRoundingPolicy[0]?.inUse === true
					? getRoundedAmt(balanceT, getRoundingPolicy[0]?.smallestDenomination)
					: balanceT,
			);
			dispatch({
				type: 'minimumValue',
				payload:
					getRoundingPolicy[0]?.inUse === true
						? getRoundedAmt(
								balanceT,
								getRoundingPolicy[0]?.smallestDenomination,
						  )
						: balanceT,
			});
		},
	});

	// DATA HANDLE & PASSING

	const getRoundedAmt = (amount, round) => {
		let roundingAmt = amount - Math.floor(amount);

		let roundedAmt = Math.round((roundingAmt + Number.EPSILON) * 100) / 100;

		let roundingMulti = Math.round(
			(roundedAmt * 100) / ((round ?? 0.05) * 100),
		);
		let finalAmt = Math.floor(amount) + (round ?? 0.05) * roundingMulti;

		return parseFloat(finalAmt.toFixed(2));
	};

	const creditCardText = data => {
		let credClass;
		setSelectedCredit(watch('cardType'));
		if (
			data === CreditCardType.AmericanExpressCard ||
			data === 'American Express Card'
		) {
			credClass = 'American Express Card';
		} else if (data === CreditCardType.DinersCard || data === 'Diners Card') {
			credClass = 'Diners Card';
		} else if (data === CreditCardType.JcbCard || data === 'JCB Card') {
			credClass = 'JCB Card';
		} else if (data === CreditCardType.Mastercard || data === 'Master Card') {
			credClass = 'Master Card';
		} else if (data === CreditCardType.UnionpayCard || data === 'UNION PAY') {
			credClass = 'UNION PAY';
		} else if (data === CreditCardType.VisaCard || data === 'Visa Card') {
			credClass = 'Visa Card';
		} else if (data === CreditCardType.DebitCard || data === 'Debit Card') {
			credClass = 'Debit Card';
		} else if (data === CreditCardType.Ewallet || data === 'E-Wallet') {
			credClass = 'E-Wallet';
		}
		return credClass;
	};

	const creditCardTypeEnum = Object.values(CreditCardType);

		const {
			loading: MenuXInhouseListLoading,
			data: { getMenuXInhouseList } = { getMenuXInhouseList: [] },
		} = useGetMenuXInhouseListQuery({
			skip: !hotelID || !state?.outletID,
			variables: {
				hotelID,
				outletID: state?.outletID,
			},
			fetchPolicy: 'network-only',
			onCompleted: ({ getMenuXInhouseList }) => {
				let defaultOrder = state?.selectedOrder;
				if (defaultOrder?.patronAccountID !== null) {
					let defaultGuest = getMenuXInhouseList?.data?.MenuXInhouseList?.filter(
						x => x?.RegistrationID === defaultOrder?.patronAccountID,
					)[0];
					if (defaultGuest?.GuestType === 'RoomGuest') {
						setDefaultRoom(defaultGuest);
					} else if (defaultGuest?.GuestType === 'NonGuest') {
						setDefaultNonGuest(defaultGuest);
					} else if (defaultGuest?.GuestType === 'Suspend Folio') {
						setDefaultFolio(defaultGuest);
					}
				}
			},
		});

			const [
				loadOfficer,
				{ loading: loadingOfficer, data: { getOfficer } = { getOfficer: [] } },
			] = useGetOfficerLazyQuery({
				fetchPolicy: 'network-only',
				onCompleted: ({ getOfficer }) => {
					let defaultOrder = state?.selectedOrder;
					if (defaultOrder?.patronAccountID !== null) {
						setDefaultOfficer(
							getOfficer?.filter(x => x?.ID === defaultOrder?.patronAccountID)[0],
						);
					}
				},
			});

				const [
					loadStaff,
					{ loading: loadingStaff, data: { getStaff } = { getStaff: [] } },
				] = useGetStaffLazyQuery({
					fetchPolicy: 'network-only',
					onCompleted: ({ getStaff }) => {
						let defaultOrder = state?.selectedOrder;
						if (defaultOrder?.patronAccountID !== null) {
							setDefaultStaff(
								getStaff?.filter(x => x?.ID === defaultOrder?.patronAccountID)[0],
							);
						}
					},
				});

		const { filteredList, handleSearch, setOriginalListing } = useFuseSearch();

		console.log(hotelID, state?.outletID, 'query variables');

				console.log(getMenuXInhouseList?.data?.MenuXInhouseList, 'inhouse list');

			console.log(filteredList, 'filteredList');

		const [tempState, setTempState] = useState('');

			const [filterCond, setFilterCond] = useState({
				room: false,
				nonGuest: false,
				folio: false,
				debtor: false,
				officer: false,
				staff: false,
			});
	
	const [pendingProceed, setPendingProceed] = useState(false);

	console.log(pendingProceed, 'pendingProceed');



	// const CardDropDownDownField = () => {
	// 	return (
	// 		<TextField select>
	// 			{creditCardTypeEnum?.map((el: any, index: number) => (
	// 				<MenuItem key={index} value={el}>
	// 					<span className="text-noflow">{creditCardText(el)}</span>
	// 				</MenuItem>
	// 			))}
	// 		</TextField>
	// 	);
	// };

		const CardDropDownDownField = () => {
			const cardDebtors = getMenuXDebtorList?.data?.MenuXDebtorList?.filter(
				x => x?.GuestStatus === 'CARD',
			);

			if (
				isCreditPaymentWaitingForDebtorList(
					integrateCityLedger,
					MenuXDebtorListLoading,
				)
			) {
				return (
					<TextField select disabled value="">
						<MenuItem value="">
							<span className="text-noflow">Loading credit accounts...</span>
						</MenuItem>
					</TextField>
				);
			}

			if (!MenuXDebtorListLoading && cardDebtors?.length > 0) {
				return (
					<TextField select>
						{cardDebtors?.map((el: any, index: number) => (
							<MenuItem key={el?.RegistrationID ?? index} value={el}>
								<span className="text-noflow">
									{creditCardText(el?.GuestType)}
								</span>
							</MenuItem>
						))}
					</TextField>
				);
			}

			return (
				<TextField select>
					{creditCardTypeEnum?.map((el: any, index: number) => (
						<MenuItem key={index} value={el}>
							<span className="text-noflow">{creditCardText(el)}</span>
						</MenuItem>
					))}
				</TextField>
			);
		};

	const filterPaymentClass = paymentClass => {
		const array = state?.lastArray?.filter(
			x => x?.paymentClass === paymentClass,
		);

		return array;
	};

	const isPaymentMethodDisabled = (
		selectedClass: PaymentClass,
		paymentClass: PaymentClass,
	) => {
		const disableRoomNonGuestSuspendFolio =
			paymentClass === PaymentClass.Room ||
			paymentClass === PaymentClass.NonGuest ||
			paymentClass === PaymentClass.SuspendFolio;

		const disableCreditRoomNonGuestSuspendFolio =
			paymentClass === PaymentClass.Credit ||
			paymentClass === PaymentClass.Room ||
			paymentClass === PaymentClass.NonGuest ||
			paymentClass === PaymentClass.SuspendFolio;

		const disableRoomDebtorNonGuestSuspendFolio =
			paymentClass === PaymentClass.Room ||
			paymentClass === PaymentClass.Debtor ||
			paymentClass === PaymentClass.NonGuest ||
			paymentClass === PaymentClass.SuspendFolio;

		switch (selectedClass) {
			case PaymentClass.Cash:
				return disableRoomNonGuestSuspendFolio;
			case PaymentClass.Credit:
				return disableRoomDebtorNonGuestSuspendFolio;
			case PaymentClass.Cheque:
				return disableCreditRoomNonGuestSuspendFolio;
			case PaymentClass.BankTt:
				return disableRoomNonGuestSuspendFolio;
			case PaymentClass.Online:
				return disableCreditRoomNonGuestSuspendFolio;
			case PaymentClass.Voucher:
				return disableCreditRoomNonGuestSuspendFolio;
			case PaymentClass.Member:
				return disableCreditRoomNonGuestSuspendFolio;
			case PaymentClass.Staff:
				return disableCreditRoomNonGuestSuspendFolio;
			case PaymentClass.Officer:
				return disableCreditRoomNonGuestSuspendFolio;
			case PaymentClass.Room:
				return paymentClass !== PaymentClass.Room;
			case PaymentClass.Debtor:
				return disableCreditRoomNonGuestSuspendFolio;
			case PaymentClass.NonGuest:
				return paymentClass !== PaymentClass.NonGuest;
			case PaymentClass.SuspendFolio:
				return paymentClass !== PaymentClass.SuspendFolio;
			case PaymentClass.Skipper:
				return disableCreditRoomNonGuestSuspendFolio;
			case PaymentClass.Others:
				return disableCreditRoomNonGuestSuspendFolio;
			default:
				return false;
		}
	};

	const getFirstSelectedPaymentClass = (payments: any[] = []) =>
		payments
			?.filter(x => x?.selected === true)
			?.slice()
			?.sort((a, b) => (a?.paymentSort ?? 0) - (b?.paymentSort ?? 0))[0]
			?.paymentClass ?? null;

	const getSelectedPaymentClasses = (payments: any[] = []) =>
		payments
			?.filter(x => x?.selected === true)
			?.map(x => x?.paymentClass)
			?.filter(Boolean) ?? [];

	// Credit Card and Debtor can never be used together, regardless of selection order
	const isCreditDebtorMutuallyExclusive = (
		selectedClasses: PaymentClass[],
		paymentClass: PaymentClass,
	) => {
		const hasCredit = selectedClasses.includes(PaymentClass.Credit);
		const hasDebtor = selectedClasses.includes(PaymentClass.Debtor);
		if (hasCredit && paymentClass === PaymentClass.Debtor) return true;
		if (hasDebtor && paymentClass === PaymentClass.Credit) return true;
		return false;
	};

		const isSignature = () => {
			const isSignature =
				array?.filter(
					x =>
						x?.paymentClass === PaymentClass.Room ||
						x?.paymentClass === PaymentClass.Debtor ||
						x?.paymentClass === PaymentClass.NonGuest ||
						x?.paymentClass === PaymentClass.SuspendFolio ||
						x?.paymentClass === PaymentClass.Member,
				)?.length > 0
					? true
					: false;
	
			return isSignature;
		};

	const cashPayment = array?.find(x => x?.paymentClass === PaymentClass.Cash);

		const isDebtor = array?.find(
			x =>
				x?.paymentClass === PaymentClass.Debtor ||
				x?.paymentClass === PaymentClass.Folio ||
				x?.paymentClass === PaymentClass.NonGuest ||
				x?.paymentClass === PaymentClass.Room,
		);

	// const isRounding = watch(`${defaultPayment}`);

	let totalT = 0,
		balanceT = 0,
		balanceT2 = 0,
		subtotalT = 0,
		roundingTotal = 0;

	// Sort the array first (make a shallow copy to avoid mutating the original)
	const sortedArray = array
		?.slice()
		?.sort((a, b) => (a?.paymentSort ?? 0) - (b?.paymentSort ?? 0));

	// Now get the last item from the sorted array
	const lastIndex = sortedArray?.length ? sortedArray.length - 1 : -1;
	const lastItem = lastIndex >= 0 ? sortedArray[lastIndex] : null;

	// Loop to calculate totalT and roundingTotal
	array
		?.slice() // optional: create a shallow copy to avoid mutating the original
		?.sort((a, b) => (a?.paymentSort ?? 0) - (b?.paymentSort ?? 0))
		?.forEach((x, index) => {
			const diff = (x?.amountPayment ?? 0) - (state?.receivedAmount ?? 0);
			const trueCashAmount =
				Math?.abs(diff) <= 0.03
					? (state?.receivedAmount ?? 0) +
					  (Number((state.receivedAmount - x.rounding).toFixed(2)) >=
							Number((subtotal - discount).toFixed(2)) ||
					  state?.receivedAmount < Number(totalT.toFixed(2))
							? x?.rounding * -1
							: 0)
					: (state?.receivedAmount ?? 0) +
					  (Number((state.receivedAmount - x.rounding).toFixed(2)) >=
							Number((subtotal - discount).toFixed(2)) ||
					  state?.receivedAmount < Number(totalT.toFixed(2))
							? x?.rounding * -1
							: 0);

			console?.log(
				trueCashAmount,
				state.receivedAmount,
				x.rounding,
				totalT,
				Number((state.receivedAmount - x.rounding).toFixed(2)) >=
					Number((subtotal - discount).toFixed(2)),
				'trueCashAmount',
			);

			if (x?.paymentClass === PaymentClass.Cash) {
				totalT += trueCashAmount;
			} else if (!isCancel) {
				totalT += x?.amountPayment ?? 0;
			}

			// Only apply rounding if this is the last item and isRounding is true
			if (index === lastIndex && x?.isRounding === true) {
				roundingTotal +=
					x?.paymentClass === PaymentClass.Cash
						? generateRoundingAmount(
								state?.receivedAmount > subtotal - discount
									? subtotal - discount
									: trueCashAmount,
								getRoundingPolicy[0]?.smallestDenomination,
								getRoundingPolicy,
						  )
						: x?.rounding;

				totalT =
					x?.paymentClass === PaymentClass.Cash
						? Number(totalT.toFixed(2))
						: Number(totalT.toFixed(2));
			}

			console?.log(
				balanceT,
				state?.receivedAmount,
				totalT,
				roundingTotal,
				'rounding1',
			);
		});

	// ✅ Now use lastItem to decide what to add to balance
	const roundingToApply =
		lastItem?.isRounding === true
			? cashPayment && lastItem?.paymentClass === PaymentClass.Cash
				? roundingTotal
				: roundingTotal
			: 0;

	// Final balance calculation
	balanceT =
		totalT >= Number(subtotal) + Number(roundingToApply) - Number(discount)
			? Number(
					Number(
						(
							subtotal +
							(roundingToApply < 0 &&
							lastItem?.paymentClass !== PaymentClass.Cash
								? 0
								: roundingToApply) -
							totalT
						).toFixed(2),
					) - Number((discount ?? 0).toFixed(2)),
			  )
			: Number(
					Number((subtotal - totalT).toFixed(2)) -
						Number((discount ?? 0).toFixed(2)),
			  );

	console?.log(
		balanceT,
		totalT,
		subtotal - discount,
		state?.receivedAmount,
		roundingToApply,
		lastItem?.paymentClass,
		array,
		'rounding12',
	);

	// balanceT = Number((total - totalT).toFixed(2));

	useEffect(() => {
		if (array?.length === 0 || array === undefined) {
			totalT = 0;
			balanceT = 0;
			dispatch({ type: 'receivedAmount', payload: 0 });
		}
		if (array?.filter(x => x?.isRounding === true)?.length > 0) {
			setIsRoundingOnce(array?.filter(x => x?.isRounding === true)?.length);
		} else {
			setIsRoundingOnce(0);
		}
	}, [array?.length]);

	useEffect(() => {
		const received = Number(state?.receivedAmount ?? 0);
		// Overpayment is only valid as cash change; non-cash (e.g. voucher)
		// cannot exceed the remaining bill amount.
		if (balanceT < 0) {
			const overpay = Math.abs(balanceT);
			if (received >= overpay) {
				setError(false);
				setErrorMessage('');
				dispatch({ type: 'changeAmount', payload: overpay });
			} else {
				setError(true);
				setErrorMessage('Amount exceeded bill amount');
				dispatch({ type: 'changeAmount', payload: 0 });
			}
		} else if (balanceT > 0) {
			setError(true);
			setErrorMessage('Insufficient amount');
			dispatch({ type: 'changeAmount', payload: 0 });
		} else {
			setError(false);
			setErrorMessage('');
			dispatch({ type: 'changeAmount', payload: 0 });
		}
	}, [balanceT, state?.receivedAmount]);

	const customSortPayment = [
		'CASH',
		'CREDIT',
		'CHEQUE',
		'BANK_TT',
		'ONLINE',
		'VOUCHER',
		'MEMBER',
		'STAFF',
		'OFFICER',
		'ROOM',
		'DEBTOR',
		'NON_GUEST',
		'SUSPEND_FOLIO',
		'SKIPPER',
		'OTHERS',
	];

	const customSort = (a, b) => {
		const indexA = customSortPayment.indexOf(a);
		const indexB = customSortPayment.indexOf(b);

		if (indexA === -1 && indexB === -1) {
			return a.localeCompare(b);
		} else if (indexA === -1) {
			return 1;
		} else if (indexB === -1) {
			return -1;
		}

		return indexA - indexB;
	};

		const [
			loadMenuXDebtorList,
			{
				called: menuXDebtorCalled,
				loading: MenuXDebtorListLoading,
				data: { getMenuXDebtorList } = { getMenuXDebtorList: [] },
			},
		] = useGetMenuXDebtorListLazyQuery({
			fetchPolicy: 'network-only',
			onCompleted: ({ getMenuXDebtorList }) => {
				let defaultOrder = state?.selectedOrder;
				if (defaultOrder?.patronAccountID !== null) {
					setDefaultDebtor(
						getMenuXDebtorList?.data?.MenuXDebtorList?.filter(
							x => x?.RegistrationID === defaultOrder?.registrationID,
						)[0],
					);
				}
			},
		});

			useEffect(() => {
			if (hotelID && state?.outletID) {
				loadMenuXDebtorList({
					variables: {
						hotelID: hotelID,
						outletID: state?.outletID,
					},
				});
			}
		}, [state?.signatureDialog, hotelID, state?.outletID, loadMenuXDebtorList]);

			 	useEffect(() => {
			if (filterCond.room) {
				setOriginalListing(getMenuXInhouseList?.data?.MenuXInhouseList);
			}
		}, [getMenuXInhouseList, filterCond.room]);

			useEffect(() => {
					if (filterCond.nonGuest) {
						setOriginalListing(getMenuXInhouseList?.data?.MenuXInhouseList);
					}
				}, [getMenuXInhouseList, filterCond.nonGuest]);
			
				useEffect(() => {
					if (filterCond.folio) {
						setOriginalListing(getMenuXInhouseList?.data?.MenuXInhouseList);
					}
				}, [getMenuXInhouseList, filterCond.folio]);
			
				useEffect(() => {
					if (filterCond.debtor) {
						setOriginalListing(getMenuXDebtorList?.data?.MenuXDebtorList);
					}
				}, [getMenuXDebtorList, filterCond.debtor]);
			
				useEffect(() => {
					if (getOfficer?.length > 0 && getOfficer && filterCond.officer) {
						setOriginalListing(getOfficer);
					}
				}, [getOfficer, filterCond.officer]);
			
				useEffect(() => {
					if (getStaff?.length > 0 && getStaff && filterCond.staff) {
						setOriginalListing(getStaff);
					}
				}, [getStaff, filterCond.staff]);
			
	
		const handleCallLazy = v => {
			if (
				(v?.paymentClass === PaymentClass.Debtor ||
					v?.paymentClass === PaymentClass.Credit) &&
				integrateCityLedger &&
				hotelID
			) {
				setFilterCond({
					debtor: true,
					officer: false,
					room: false,
					nonGuest: false,
					staff: false,
					folio: false,
				});
				if (!menuXDebtorCalled && !MenuXDebtorListLoading) {
					loadMenuXDebtorList({
						variables: {
							hotelID: hotelID,
							outletID: state?.outletID,
						},
					});
				}
			} else if (v?.paymentClass === PaymentClass.Room && hotelID) {
				setFilterCond({
					room: true,
					nonGuest: false,
					officer: false,
					debtor: false,
					staff: false,
					folio: false,
				});
			} else if (v?.paymentClass === PaymentClass.NonGuest && hotelID) {
				setFilterCond({
					room: false,
					nonGuest: true,
					officer: false,
					debtor: false,
					staff: false,
					folio: false,
				});
			} else if (v?.paymentClass === PaymentClass.SuspendFolio && hotelID) {
				setFilterCond({
					room: false,
					nonGuest: false,
					officer: false,
					debtor: false,
					staff: false,
					folio: true,
				});
			} else if (v?.paymentClass === PaymentClass.Officer) {
				setFilterCond({
					officer: true,
					debtor: false,
					room: false,
					nonGuest: false,
					staff: false,
					folio: false,
				});
				if (!loadingOfficer && getOfficer?.length === 0) {
					loadOfficer({
						variables: {
							isActive: true,
						},
					});
				}
			} else if (v?.paymentClass === PaymentClass.Staff) {
				setFilterCond({
					officer: false,
					debtor: false,
					room: false,
					nonGuest: false,
					staff: true,
					folio: false,
				});
				if (!loadingStaff && getStaff?.length === 0) {
					loadStaff({
						variables: {
							isActive: true,
						},
					});
				}
			}
		};
	let [bankTTremark, setBankTTremark] = useState(null);
	let [chequeremark, setChequeremark] = useState(null);


	const handleRadio = (v, check) => {
		setTempState('');
		const defaultState = [
			{
				type: PaymentClass.Credit,
				name: 'cardDropDown',
			},
			{
				type: PaymentClass.Cash,
				name: 'cashAmount',
			},
			{
				type: PaymentClass.Room,
				name: 'hotelSearchField',
			},
			{
				type: PaymentClass.NonGuest,
				name: 'nonGuestSearchField',
			},
			{
				type: PaymentClass.SuspendFolio,
				name: 'folioSearchField',
			},
			{
				type: PaymentClass.Debtor,
				name: 'debtorSearchField',
			},
			{
				type: PaymentClass.Officer,
				name: 'officerSearchField',
			},
			{
				type: PaymentClass.Staff,
				name: 'staffSearchField',
			},
			{
				type: PaymentClass.Voucher,
				name: 'voucher',
			},
			{
				type: PaymentClass.Others,
				name: 'others',
			},
			{
				type: PaymentClass.BankTt,
				name: 'bankTT',
			},
			{
				type: PaymentClass.Member,
				name: 'member',
			},
			{
				type: PaymentClass.Online,
				name: 'onlinePayment',
			},
			{
				type: PaymentClass.Skipper,
				name: 'skipperAccount',
			},
			{
				type: PaymentClass.Cheque,
				name: 'cheque',
			},
		];

		defaultState?.map(d => {
			if (d?.type === v?.paymentClass) {
				if (
					v?.paymentClass === PaymentClass.Cash &&
					getRoundingPolicy?.length &&
					check === true
				) {
					loadRoundingPolicy();
				}
				dispatch({
					type: d?.name,
					payload: true,
				});
			} else {
				dispatch({
					type: d?.name,
					payload: false,
				});
			}
		});
	};

	const ALLOWED_PAYMENT_CLASSES = [
		PaymentClass.Cash,
		PaymentClass.Credit,
		PaymentClass.Voucher,
		PaymentClass.Others,
		PaymentClass.BankTt,
	];

	const watchedPayments = watch('defaultPayment') || [];
	const firstSelectedPaymentClass =
		getFirstSelectedPaymentClass(watchedPayments) ??
		getFirstSelectedPaymentClass(array);
	const creditRequiresManualEntry =
		!enableOfflineTerminal &&
		array?.filter(x => x?.paymentClass === PaymentClass.Credit)?.length > 0 &&
		(isCreditPaymentWaitingForDebtorList(
			integrateCityLedger,
			MenuXDebtorListLoading,
		) ||
			watch('cardReference') === undefined ||
			watch('cardType') === undefined);

	const runPaymentSubmit = (data: any, files?: any) => {
		if (locked === false) {
			if (data) {
				onSubmit(data, files);
			} else {
				handleSubmit(formData => onSubmit(formData, files))();
			}
		}
	};

	const runTerminalPayment = async (data: any, files?: any) => {
		pendingFormDataRef.current = { data, files };
		const amount = getSelectedCreditPaymentAmount(data);
		const txnId =
			transactionId ||
			state?.selectedOrder?.docNo ||
			`TXN-${Date.now()}`;

		setTerminalDialogState('waiting');
		setTerminalErrorMessage('');

		try {
			const result = await payOnTerminal(
				buildEcrPayRequest({
					amount,
					transactionId: txnId,
					outletId: outletID,
					paymentMethod: 'CARD',
					cardBizEcrList,
				}),
			);

			if (result.approved) {
				const isMockApproval =
					String(result.approvalCode || '').startsWith('MOCK') ||
					String(result.responseMessage || '')
						.toUpperCase()
						.includes('MOCK');

				if (isMockApproval) {
					setTerminalErrorMessage(
						'Agent is in MOCK MODE — no real N950S was used. Set mockMode to false in packages/ecr-agent/config.json and restart the agent.',
					);
					setTerminalDialogState('failed');
					return;
				}

				const mergedFormData = mergeTerminalResultIntoFormData(data, result);
				applyTerminalResultToPaymentForm(setValue, mergedFormData, result);
				setTerminalDialogState('idle');
				onEcrPaymentApproved?.();
				runPaymentSubmit(mergedFormData, files);
				return;
			}

			setTerminalErrorMessage(
				result.responseMessage || 'Payment was not approved on the terminal.',
			);
			setTerminalDialogState('failed');
		} catch (err: any) {
			setTerminalErrorMessage(
				err?.message || 'Could not reach the ECR agent. Is it running?',
			);
			setTerminalDialogState('failed');
		}
	};

	const handleConfirmPayment = () => {
		handleSubmit(data => {
			const { defaultPayment } = data;
			setArray(defaultPayment?.filter(x => x?.selected === true));
		})();

		handleSubmit(data => {
			if (
				shouldUseOfflineTerminalForPayment(
					enableOfflineTerminal,
					data,
					watch('cardType'),
				)
			) {
				runTerminalPayment(data);
			} else {
				runPaymentSubmit(data);
			}
		})();
	};

	const handleTerminalRetry = () => {
		const pending = pendingFormDataRef.current;
		if (pending) {
			runTerminalPayment(pending.data, pending.files);
		}
	};

	const handleTerminalInquiry = async () => {
		const txnId = transactionId || state?.selectedOrder?.docNo || '';
		if (!txnId) {
			setTerminalErrorMessage('No transaction ID to look up.');
			return;
		}

		setTerminalDialogState('waiting');
		try {
			const result = await inquiryTerminalTransaction(txnId, outletID);
			if (result.found && result.approved) {
				const pending = pendingFormDataRef.current;
				if (pending) {
					const mergedFormData = mergeTerminalResultIntoFormData(
						pending.data,
						result,
					);
					applyTerminalResultToPaymentForm(
						setValue,
						mergedFormData,
						result,
					);
					setTerminalDialogState('idle');
					onEcrPaymentApproved?.();
					runPaymentSubmit(mergedFormData, pending.files);
					return;
				}
			}
			setTerminalErrorMessage(
				result.responseMessage ||
					'No approved transaction found for this bill.',
			);
			setTerminalDialogState('failed');
		} catch (err: any) {
			setTerminalErrorMessage(err?.message || 'Inquiry failed.');
			setTerminalDialogState('failed');
		}
	};

	const handleTerminalCancel = () => {
		setTerminalDialogState('idle');
		setTerminalErrorMessage('');
		pendingFormDataRef.current = null;
	};
	const selectedFromWatch = getSelectedPaymentClasses(watchedPayments);
	const selectedPaymentClasses =
		selectedFromWatch.length > 0
			? selectedFromWatch
			: getSelectedPaymentClasses(array);

	return (
		<>
			<CommonDialog
				open={state?.paymentDialog}
				hidden={state?.signatureDialog}
				fullWidth
				disableEnforceFocus
				onClose={() => {
					setLocked(false);
					setLocked2(false);
					dispatch({ type: 'receivedAmount', payload: 0 });
					dispatch({ type: 'paymentDialog', payload: false });
					setSelectedRoom({});
					setSelectedNonGuest({});
					setSelectedFolio({});
					setSelectedDebtor({});
					setSelectedOfficer({});
					setSelectedCredit({});
					setSelectedStaff({});
					setBankTTremark(null);
					setChequeremark(null);
					setIsTouch(false);
					dispatch({ type: 'radioError', payload: false });
					setCancel(true);
					dispatch({ type: 'disablePaymentClass', payload: null });
					setArray(null);
					handleSubmit(data => {
						const { defaultPayment } = data;
						setArray(defaultPayment?.filter(x => x?.selected === true));
					})();
				}}
				sections={{
					header: {
						dynamic: (
							<>
								<div className="">
									<div className="dialog-dynamic-content">
										<div className="session">
											<div className="flex session">
												<div
													className="title highlight-text flex-space"
													style={{ color: '#ff9800' }}
												>
													{'Payment'}
												</div>
												<div className="highlight-text title">
													{currencyCode +
														(Number(subtotal || 0) - Number(discount || 0)).toLocaleString('en-MY', {
															minimumFractionDigits: 2,
															maximumFractionDigits: 2,
														})}
												</div>
											</div>
										</div>
									</div>
								</div>
							</>
						),
					},
					body: () => (
						<>
							<span className="mdDesc" style={{ paddingLeft: '15px' }}>
								{'Payment Method'}
							</span>

							<RadioGroup
								aria-label="paymentMethod"
								onChange={e => {
									register(`defaultPaymentID`);
									setValue(`defaultPaymentID`, e.target.value);
								}}
							>
								{getDefaultPayment
									?.filter(s => s?.isActive === true)
									?.filter(s => s?.paymentClass !== PaymentClass.UnsettledBill)
									// ?.filter(s =>
									// 	ALLOWED_PAYMENT_CLASSES.includes(s?.paymentClass),
									// )
									?.sort((a, b) => customSort(a?.paymentClass, b?.paymentClass))
									?.map((v, i) => {
										const defaultPayment = `defaultPayment[${i}]`;

										const isSelected = watch(`${defaultPayment}.selected`);
										const hasNoBalance = balanceT <= 0;

										const isDisabled =
											hasNoBalance && !isSelected
												? true
												: (firstSelectedPaymentClass
														? isPaymentMethodDisabled(
																firstSelectedPaymentClass,
																v?.paymentClass,
														  )
														: false) ||
												  isCreditDebtorMutuallyExclusive(
														selectedPaymentClasses,
														v?.paymentClass,
												  );

										return (
											<>
												<>
													<Grid container>
														<Grid item xs={1}>
															<FormControl
																component="fieldset"
																style={{ paddingRight: 'revert' }}
															>
																<Checkbox
																	onChange={e => {
																		const isChecking = e.target.checked;

																		register(
																			`${defaultPayment}.defaultPaymentID`,
																		);
																		setValue(
																			`${defaultPayment}.defaultPaymentID`,
																			v?.ID,
																		);

																		register(`${defaultPayment}.paymentClass`);
																		setValue(
																			`${defaultPayment}.paymentClass`,
																			v?.paymentClass,
																		);

																		register(`${defaultPayment}.amountPayment`);

																		setValue(
																			`${defaultPayment}.amountPayment`,
																			isChecking && balanceT < 0
																				? 0
																				: !isChecking
																				? 0
																				: balanceT,
																		);

																		if (isChecking) {
																			register(`${defaultPayment}.paymentSort`);
																			setValue(
																				`${defaultPayment}.paymentSort`,
																				(sortCounter.current += 1),
																			);
																		} else {
																			setValue(`${defaultPayment}.paymentSort`, null);
																		}

																		register(
																			`${defaultPayment}.registrationID`,
																		);
																		setValue(
																			`${defaultPayment}.registrationID`,
																			state?.selectedOrder?.patronAccountID,
																		);

																		register(`${defaultPayment}.isRounding`);
																		setValue(
																			`${defaultPayment}.isRounding`,
																			v?.isRounding,
																		);

																		// register(
																		// 	`${defaultPayment}.remainingBalance`,
																		// );

																		// setValue(
																		// 	`${defaultPayment}.remainingBalance`,
																		// 	watch(`${defaultPayment}.selected`) ===
																		// 		true &&
																		// 		balanceT -
																		// 			watch(
																		// 				`${defaultPayment}.amountPayment`,
																		// 			) <
																		// 			0
																		// 		? 0
																		// 		: watch(
																		// 				`${defaultPayment}.selected`,
																		// 		  ) === false
																		// 		? 0
																		// 		: balanceT -
																		// 		  watch(
																		// 				`${defaultPayment}.amountPayment`,
																		// 		  ),
																		// );

																		setSelectedPayment(
																			watch(`${defaultPayment}`),
																		);

																		register(`${defaultPayment}.length`);
																		setValue(
																			`${defaultPayment}.length`,
																			array?.length ?? 0,
																		);

																		dispatch({
																			type: 'isPassNextPaymentRounding',
																			payload: balanceT < 0 ? false : true,
																		});

																		register(`${defaultPayment}.rounding`);

																		setValue(
																			`${defaultPayment}.rounding`,
																			isChecking && balanceT < 0
																				? 0
																				: !isChecking
																				? 0
																				: watch(
																						`${defaultPayment}.isRounding`,
																				  ) === true
																				? rounding
																				: 0,
																		);

																		register(`${defaultPayment}.isUserEdited`);
																		setValue(
																			`${defaultPayment}.isUserEdited`,
																			false,
																		);

																		handleSubmit(data => {
																			const { defaultPayment } = data;
																			const selected =
																				defaultPayment?.filter(
																					x => x?.selected === true,
																				) ?? [];
																			setArray(selected);
																			dispatch({
																				type: 'disablePaymentClass',
																				payload:
																					getFirstSelectedPaymentClass(
																						selected,
																					),
																			});
																			setCancel(false);
																		})();
																	}}
																	onClick={e => {
																		if (watch(`defaultPaymentID`) !== v?.ID) {
																			handleCallLazy(v);
																			handleRadio(
																				v,
																				watch(`${defaultPayment}.selected`),
																			);
																			chargesRefetch();
																			setSelectedCredit({});

																			if (
																				watch(`${defaultPayment}.selected`) ===
																					false &&
																				watch(`${defaultPayment}.length`) === 0
																			) {
																				dispatch({
																					type: 'disablePaymentClass',
																					payload: null,
																				});
																				setSelectedRoom({});
																				setSelectedNonGuest({});
																				setSelectedFolio({});
																				setSelectedDebtor({});
																				setSelectedOfficer({});
																				setSelectedStaff({});
																				setSelectedCredit({});
																				setSelectedPayment(null);
																			} else if (
																				watch(`${defaultPayment}.selected`) ===
																					false &&
																				watch(
																					`${defaultPayment}.paymentClass`,
																				) === PaymentClass.Cash
																			) {
																				dispatch({
																					type: 'receivedAmount',
																					payload: 0,
																				});
																			}
																		}
																	}}
																	name={`${defaultPayment}.selected`}
																	inputRef={register()}
																	color="primary"
																	disabled={isDisabled}
																/>
															</FormControl>
														</Grid>

														<Grid
															item
															xs={6}
															style={{
																paddingTop: '10px',
																paddingLeft: '14px',
															}}
														>
															<div> {v?.paymentTypeInfo?.description} </div>
														</Grid>

														{watch(`${defaultPayment}.selected`) &&
															v?.paymentClass !== PaymentClass.Cash && (
																<Grid item xs={5}>
																	<div className="desc text-noflow">
																		{'Amount'}
																	</div>
																	<div
																		className="desc form-visitor-price"
																		style={{
																			color: '#ff9800',
																			fontWeight: 'bold',
																			marginTop: '-9px',
																		}}
																	>
																		<Controller
																			render={({ onChange, onBlur, value }) => (
																				<NumberFormat
																					customInput={TextField}
																					allowNegative={false}
																					fullWidth
																					autoComplete="off"
																					isNumericString
																					decimalScale={2}
																					fixedDecimalScale
																					thousandSeparator
																					defaultValue={
																						balanceT < 0
																							? 0
																							: watch(
																									`${defaultPayment}.isRounding`,
																							  ) === true &&
																							  state?.isPassNextPaymentRounding ===
																									true &&
																							  Math?.abs(
																									balanceT + roundingToApply,
																							  ) !== subtotal
																							? getRoundedAmt(
																									balanceT ?? 0,
																									getRoundingPolicy[0]
																										?.smallestDenomination,
																							  )
																							: watch(
																									`${defaultPayment}.isRounding`,
																							  ) === true &&
																							  watch(
																									`${defaultPayment}.length`,
																							  ) === 0
																							? getRoundedAmt(
																									balanceT ?? 0,
																									getRoundingPolicy[0]
																										?.smallestDenomination,
																							  )
																							: balanceT
																					}
																					variant="outlined"
																					margin="dense"
																					max={balanceT}
																					className="custom-add desc"
																					onValueChange={(value: any) => {
																						const { floatValue } = value;

																						const result = (watch(
																							`${defaultPayment}.selected`,
																						) === true &&
																						watch(
																							`${defaultPayment}.amountPayment`,
																						) -
																							Number(floatValue?.toFixed(2)) <
																							0
																							? 0
																							: watch(
																									`${defaultPayment}.selected`,
																							  ) === false
																							? 0
																							: Number(
																									watch(
																										`${defaultPayment}.amountPayment`,
																									)?.toFixed(2),
																							  ) -
																							  Number(floatValue?.toFixed(2))
																						)?.toFixed(2);

																						register(
																							`${defaultPayment}.isUserEdited`,
																						);
																						setValue(
																							`${defaultPayment}.isUserEdited`,
																							true,
																						);

																						// register(
																						// 	`${defaultPayment}.remainingBalance`,
																						// );
																						// setValue(
																						// 	`${defaultPayment}.remainingBalance`,
																						// 	parseFloat(result),
																						// );

																						register(
																							`${defaultPayment}.rounding`,
																						);
																						setValue(
																							`${defaultPayment}.rounding`,
																							watch(
																								`${defaultPayment}.isRounding`,
																							) === true &&
																								watch(
																									`${defaultPayment}.isUserEdited`,
																								) === false
																								? generateRoundingAmount(
																										floatValue,
																										getRoundingPolicy[0]
																											?.smallestDenomination,
																										getRoundingPolicy,
																								  )
																								: watch(
																										`${defaultPayment}.isRounding`,
																								  ) === true &&
																								  watch(
																										`${defaultPayment}.isUserEdited`,
																								  ) === true
																								? generateRoundingAmount(
																										balanceT < 0
																											? state?.receivedAmount >
																											  0
																												? floatValue
																												: 0
																											: floatValue <=
																													balanceT &&
																											  state?.receivedAmount ===
																													0
																											? floatValue
																											: floatValue,
																										getRoundingPolicy[0]
																											?.smallestDenomination,
																										getRoundingPolicy,
																								  )
																								: 0,
																						);

																						register(
																							`${defaultPayment}.amountPayment`,
																						);
																						setValue(
																							`${defaultPayment}.amountPayment`,
																							watch(
																								`${defaultPayment}.isRounding`,
																							) === true &&
																								watch(
																									`${defaultPayment}.isUserEdited`,
																								) === false
																								? getRoundedAmt(
																										floatValue,
																										getRoundingPolicy[0]
																											?.smallestDenomination,
																								  )
																								: watch(
																										`${defaultPayment}.isRounding`,
																								  ) === true &&
																								  watch(
																										`${defaultPayment}.isUserEdited`,
																								  ) === true
																								? balanceT < 0
																									? state?.receivedAmount > 0
																										? floatValue
																										: floatValue
																									: floatValue <= balanceT &&
																									  state?.receivedAmount === 0
																									? floatValue
																									: floatValue
																								: floatValue,
																						);

																						handleSubmit(data => {
																							const { defaultPayment } = data;
																							setArray(
																								defaultPayment?.filter(
																									x => x?.selected === true,
																								),
																							);
																						})();
																					}}
																				/>
																			)}
																			name={`patron`}
																			control={control}
																			ref={register}
																			className="desc custom-add"
																		/>
																	</div>
																</Grid>
															)}
													</Grid>

													{watch(`${defaultPayment}.selected`) &&
														error === true && (
															<span
																className="desc"
																style={{ color: 'red', textAlign: 'right' }}
															>
																{errorMessage}
															</span>
														)}

													{watch(`${defaultPayment}.selected`) &&
													watch(`${defaultPayment}.paymentClass`) ===
														PaymentClass.Voucher ? (
														<Grid container>
															<Grid
																item
																xs={1}
																style={{
																	maxWidth: isDesktop
																		? 'calc(5%)'
																		: 'calc(10%)',
																}}
															></Grid>
															<Grid item xs={10} style={{ marginLeft: '4px' }}>
																<Controller
																	render={({ onChange, onBlur, value }) => (
																		<TextField
																			fullWidth
																			autoComplete="off"
																			style={{
																				marginBottom: '0px',
																				marginTop: '0px',
																			}}
																			margin="dense"
																			label="Voucher Code"
																			onChange={e => {
																				register(
																					`${defaultPayment}.referenceNo`,
																				);
																				setValue(
																					`${defaultPayment}.referenceNo`,
																					e.target.value,
																				);
																			}}
																		/>
																	)}
																	name="referenceNo"
																	label={'Voucher Code'}
																	fullWidth
																	autoComplete="off"
																	multiline={false}
																	margin="dense"
																	ref={register}
																	control={control}
																	className="referenceNo"
																	helperText={
																		state?.radioError &&
																		watch('referenceNo') === undefined
																			? 'Voucher Code must not be empty'
																			: null
																	}
																	error={
																		state?.radioError &&
																		watch('referenceNo') === undefined
																	}
																/>
															</Grid>
														</Grid>
													) : null}

													{watch(`${defaultPayment}.selected`) &&
													watch(`${defaultPayment}.paymentClass`) ===
														PaymentClass.BankTt ? (
														<Grid container>
															<Grid
																item
																xs={1}
																style={{
																	maxWidth: isDesktop
																		? 'calc(5%)'
																		: 'calc(10%)',
																}}
															></Grid>
															<Grid item xs={10} style={{ marginLeft: '4px' }}>
																<Controller
																	render={({ onChange, onBlur, value }) => (
																		<TextField
																			fullWidth
																			autoComplete="off"
																			style={{
																				marginBottom: '0px',
																				marginTop: '0px',
																			}}
																			margin="dense"
																			label="Remarks"
																			onChange={e => {
																				register(`${defaultPayment}.remark`);
																				setValue(
																					`${defaultPayment}.remark`,
																					e.target.value,
																				);
																			}}
																		/>
																	)}
																	name="remark"
																	label={'Remarks'}
																	fullWidth
																	autoComplete="off"
																	multiline={false}
																	margin="dense"
																	ref={register}
																	control={control}
																	className="remark"
																	helperText={
																		state?.radioError &&
																		watch('remark') === undefined
																			? 'Input must not be empty'
																			: null
																	}
																	error={
																		state?.radioError &&
																		watch('remark') === undefined
																	}
																/>
															</Grid>
														</Grid>
													) : null}

													{watch(`${defaultPayment}.selected`) &&
													watch(`${defaultPayment}.paymentClass`) ===
														PaymentClass.Others ? (
														<Grid container>
															<Grid
																item
																xs={1}
																style={{
																	maxWidth: isDesktop
																		? 'calc(5%)'
																		: 'calc(10%)',
																}}
															></Grid>
															<Grid item xs={10} style={{ marginLeft: '4px' }}>
																<Controller
																	render={({ onChange, onBlur, value }) => (
																		<TextField
																			fullWidth
																			autoComplete="off"
																			style={{
																				marginBottom: '0px',
																				marginTop: '0px',
																			}}
																			margin="dense"
																			label="Remarks"
																			onChange={e => {
																				register(
																					`${defaultPayment}.referenceNo`,
																				);
																				setValue(
																					`${defaultPayment}.referenceNo`,
																					e.target.value,
																				);
																			}}
																		/>
																	)}
																	name="referenceNo"
																	label={'Remarks'}
																	fullWidth
																	autoComplete="off"
																	multiline={false}
																	margin="dense"
																	ref={register}
																	control={control}
																	className="referenceNo"
																	helperText={
																		state?.radioError &&
																		watch('referenceNo') === undefined
																			? 'Input must not be empty'
																			: null
																	}
																	error={
																		state?.radioError &&
																		watch('referenceNo') === undefined
																	}
																/>
															</Grid>
														</Grid>
													) : null}

													{watch(`${defaultPayment}.selected`) === true &&
													watch(`${defaultPayment}.paymentClass`) ===
														PaymentClass.Cash ? (
														<Grid container>
															<Grid
																item
																xs={1}
																style={{
																	maxWidth: isDesktop
																		? 'calc(5%)'
																		: 'calc(10%)',
																}}
															></Grid>

															<Grid
																item
																xs={5}
																style={{
																	marginRight: '4px',
																}}
															>
																<Controller
																	render={({ onChange, onBlur, value }) => (
																		<NumberFormat
																			customInput={TextField}
																			fullWidth
																			autoComplete="off"
																			isNumericString
																			thousandSeparator
																			decimalScale={2}
																			fixedDecimalScale
																			style={{
																				marginBottom: '0px',
																				marginTop: '0px',
																			}}
																			label="Received Amt"
																			margin="dense"
																			value={state?.receivedAmount}
																			defaultValue={state?.minimumValue}
																			onValueChange={e => {
																				register(
																					`${defaultPayment}.isUserEdited`,
																				);
																				setValue(
																					`${defaultPayment}.isUserEdited`,
																					true,
																				);

																				dispatch({
																					type: 'isPassNextPaymentRounding',
																					payload: balanceT < 0 ? false : true,
																				});

																				dispatch({
																					type: 'receivedAmount',
																					payload:
																						getRoundingPolicy[0]?.inUse === true
																							? getRoundedAmt(
																									e?.floatValue ?? 0,
																									getRoundingPolicy[0]
																										?.smallestDenomination,
																							  )
																							: state?.receivedAmount,
																				});

																				setValue(
																					'receivedAmount',
																					getRoundingPolicy[0]?.inUse === true
																						? getRoundedAmt(
																								e?.floatValue,
																								getRoundingPolicy[0]
																									?.smallestDenomination,
																						  )
																						: state?.receivedAmount,
																				);

																				register(`${defaultPayment}.rounding`);
																				setValue(
																					`${defaultPayment}.rounding`,
																					watch(
																						`${defaultPayment}.isRounding`,
																					) === true &&
																						watch(
																							`${defaultPayment}.isUserEdited`,
																						) === false
																						? rounding
																						: watch(
																								`${defaultPayment}.isRounding`,
																						  ) === true &&
																						  watch(
																								`${defaultPayment}.isUserEdited`,
																						  ) === true &&
																						  (balanceT <= 0.03 ||
																								subtotal - e?.floatValue <=
																									0.03)
																						? rounding
																						: rounding,
																				);

																				register(
																					`${defaultPayment}.amountPayment`,
																				);
																				setValue(
																					`${defaultPayment}.amountPayment`,
																					Math?.abs(subtotal - e?.floatValue) <=
																						0.03
																						? Number(subtotal?.toFixed(2))
																						: balanceT <= 0.03
																						? balanceT + e?.floatValue
																						: e?.floatValue,
																				);
																				handleSubmit(data => {
																					const { defaultPayment } = data;
																					setArray(
																						defaultPayment?.filter(
																							x => x?.selected === true,
																						),
																					);
																				})();
																			}}
																			helperText={
																				!!!watch('receivedAmount')
																					? 'Amount is required'
																					: null
																			}
																			error={
																				!!!watch('receivedAmount')
																					? true
																					: false
																			}
																		/>
																	)}
																	style={{
																		paddingBottom: '0px',
																		float: 'right',
																	}}
																	name="receivedAmount"
																	label="Received Amt"
																	control={control}
																	ref={register}
																/>
															</Grid>
															<Grid item xs={5} style={{ marginLeft: '4px' }}>
																<Controller
																	render={({ onChange, onBlur, value }) => (
																		<NumberFormat
																			customInput={TextField}
																			fullWidth
																			autoComplete="off"
																			isNumericString
																			thousandSeparator
																			decimalScale={2}
																			fixedDecimalScale
																			style={{
																				marginBottom: '0px',
																				marginTop: '0px',
																			}}
																			label="Change Amt"
																			disabled
																			margin="dense"
																			value={
																				balanceT < 0 &&
																				Number(state?.receivedAmount ?? 0) >=
																					Math.abs(balanceT)
																					? Math.abs(
																							getRoundedAmt(
																								Math.abs(balanceT),
																								getRoundingPolicy[0]
																									?.smallestDenomination,
																							),
																					  )
																					: 0
																			}
																			defaultValue={0}
																		/>
																	)}
																	style={{
																		paddingBottom: '0px',
																		float: 'right',
																	}}
																	name="changeAmount"
																	label="Change Amt"
																	control={control}
																	ref={register}
																/>
															</Grid>
														</Grid>
													) : null}

													{watch(`${defaultPayment}.selected`) &&
													watch(`${defaultPayment}.paymentClass`) ===
														PaymentClass.Credit ? (
														<Grid container>
															<Grid
																item
																xs={1}
																style={{
																	maxWidth: isDesktop
																		? 'calc(5%)'
																		: 'calc(10%)',
																}}
															></Grid>

															{enableOfflineTerminal ? (
																<Grid item xs={10}>
																	<Typography
																		variant="body2"
																		color="textSecondary"
																		style={{ padding: '8px 0' }}
																	>
																		Card details will be filled automatically from
																		the payment terminal when you click Confirm.
																	</Typography>
																</Grid>
															) : (
																<>
															<Grid
																item
																xs={5}
																style={{
																	marginRight: '4px',
																}}
															>
																<Controller
																	as={CardDropDownDownField()}
																	label={'Card Type'}
																	name={'cardType'}
																	style={{
																		marginTop: '0px',
																		marginBottom: '0px',
																	}}
																	autoComplete="off"
																	control={control}
																	multiline
																	fullWidth
																	margin="dense"
																	ref={register}
																	helperText={
																		filterPaymentClass(PaymentClass.Credit)
																			?.length > 0 &&
																		filterPaymentClass(PaymentClass.Credit)[0]
																			?.creditCardType === undefined &&
																		watch('cardType') === undefined
																			? 'Must select at least one option'
																			: filterPaymentClass(PaymentClass.Credit)
																					?.length > 0 &&
																			  filterPaymentClass(
																					PaymentClass.Credit,
																			  )[0]?.creditCardType === undefined &&
																			  Number(
																					watch('cardType')?.CreditBalance,
																			  ) < balanceT
																			? 'Not enough Credit Balance!'
																			: null
																	}
																	error={
																		(filterPaymentClass(PaymentClass.Credit)
																			?.length > 0 &&
																			filterPaymentClass(PaymentClass.Credit)[0]
																				?.creditCardType === undefined &&
																			watch('cardType') === undefined) ||
																		(filterPaymentClass(PaymentClass.Credit)
																			?.length > 0 &&
																			filterPaymentClass(PaymentClass.Credit)[0]
																				?.creditCardType === undefined &&
																			Number(watch('cardType')?.CreditBalance) <
																				balanceT)
																	}
																/>
															</Grid>
															<Grid item xs={5} style={{ marginLeft: '4px' }}>
																<Controller
																	as={
																		<NumberFormat
																			allowEmptyFormatting
																			customInput={TextField}
																			fullWidth
																			autoComplete="off"
																			style={{
																				marginBottom: '0px',
																				marginTop: '0px',
																			}}
																			margin="dense"
																			onValueChange={(value: any) => {
																				const { formattedValue } = value;
																				register(`${defaultPayment}.cardRef`);
																				setValue(
																					`${defaultPayment}.cardRef`,
																					formattedValue,
																				);
																			}}
																		/>
																	}
																	name="cardReference"
																	label={'Card Ref.'}
																	fullWidth
																	autoComplete="off"
																	multiline={false}
																	margin="dense"
																	ref={register}
																	control={control}
																	className="cardReference"
																	helperText={
																		filterPaymentClass(PaymentClass.Credit)
																			?.length > 0 &&
																		filterPaymentClass(PaymentClass.Credit)[0]
																			?.cardNo === undefined &&
																		watch('cardReference') === undefined
																			? 'Card Ref. must not be empty'
																			: null
																	}
																	error={
																		filterPaymentClass(PaymentClass.Credit)
																			?.length > 0 &&
																		filterPaymentClass(PaymentClass.Credit)[0]
																			?.cardNo === undefined &&
																		watch('cardReference') === undefined
																	}
																/>
															</Grid>
																</>
															)}
														</Grid>
													) : null}

													{!MenuXInhouseListLoading &&
														filterCond?.room &&
														v?.paymentClass == PaymentClass.Room &&
														watch(`${defaultPayment}.selected`) && (
															<SearchField
																data={v?.paymentClass}
																paymentEnum={PaymentClass.Room}
																tempState={tempState}
																reducerState={state?.hotelSearchField}
																label={'Search Hotel Guest'}
																defaultListField={{
																	defaultField: state?.defaultRoom,
																	paymentEnum: PaymentClass.Room,
																	data: 'GuestName',
																	type: 'RoomNo',
																	balance: 'CreditBalance',
																}}
																listField={{
																	filterCondition: 'GuestType',
																	fieldKey: ['RoomGuest'],
																	arg: 'RegistrationID',
																	filteredList: filteredList,
																	setSelectedListItem: setSelectedRoom,
																	selectedListItem: selectedRoom,
																	data: 'GuestName',
																	type: 'RoomNo',
																	balance: 'CreditBalance',
																	paymentEnum: PaymentClass.Room,
																	register: register,
																	setValue: setValue,
																	defaultPayment: defaultPayment,
																}}
																selectedField={selectedRoom}
																defaultField={defaultRoom}
																selectedOrder={selectedOrder}
																setSelectedField={setSelectedRoom}
																total={watch(`${defaultPayment}.amountPayment`)}
																onChange={e => {
																	handleSearch(`"${e?.target?.value}"`, [
																		`GuestName`,
																		`RoomNo`,
																	]);
																	if (filteredList?.length === 1) {
																		setSelectedRoom(filteredList[0]);
																	}
																	setTempState(e?.target?.value);
																}}
																defaultValue={
																	selectedOrder?.patronAccountID
																		? getMenuXInhouseList?.data?.MenuXInhouseList?.filter(
																				x =>
																					x?.RegistrationID ===
																						selectedOrder?.patronAccountID &&
																					x?.GuestType === 'RoomGuest',
																			)[0]?.GuestName
																		: null
																}
															/>
														)}

													{!MenuXInhouseListLoading &&
														filterCond?.nonGuest &&
														v?.paymentClass == PaymentClass.NonGuest &&
														watch(`${defaultPayment}.selected`) && (
															<SearchField
																data={v?.paymentClass}
																paymentEnum={PaymentClass.NonGuest}
																tempState={tempState}
																reducerState={state?.nonGuestSearchField}
																label={'Search Guest'}
																defaultListField={{
																	defaultField: defaultNonGuest,
																	paymentEnum: PaymentClass.NonGuest,
																	data: 'GuestName',
																	type: 'RoomNo',
																	balance: 'CreditBalance',
																}}
																listField={{
																	filterCondition: 'GuestType',
																	fieldKey: ['NonGuest'],
																	arg: 'RegistrationID',
																	filteredList: filteredList,
																	setSelectedListItem: setSelectedNonGuest,
																	selectedListItem: selectedNonGuest,
																	data: 'GuestName',
																	secondaryData: 'ReferenceID',
																	type: 'RoomNo',
																	balance: 'CreditBalance',
																	paymentEnum: PaymentClass.NonGuest,
																	register: register,
																	setValue: setValue,
																	defaultPayment: defaultPayment,
																}}
																selectedField={selectedNonGuest}
																defaultField={defaultNonGuest}
																selectedOrder={selectedOrder}
																setSelectedField={setSelectedNonGuest}
																total={watch(`${defaultPayment}.amountPayment`)}
																onChange={e => {
																	handleSearch(`"${e?.target?.value}"`, [
																		`GuestName`,
																		`RoomNo`,
																	]);
																	if (filteredList?.length === 1) {
																		setSelectedNonGuest(filteredList[0]);
																	}
																	setTempState(e?.target?.value);
																}}
																defaultValue={
																	selectedOrder?.patronAccountID
																		? getMenuXInhouseList?.data?.MenuXInhouseList?.filter(
																				x =>
																					x?.RegistrationID ===
																						selectedOrder?.patronAccountID &&
																					x?.GuestType === 'NonGuest',
																			)[0]?.GuestName
																		: null
																}
															/>
														)}

													{!MenuXInhouseListLoading &&
														filterCond?.folio &&
														v?.paymentClass == PaymentClass.SuspendFolio &&
														watch(`${defaultPayment}.selected`) && (
															<SearchField
																data={v?.paymentClass}
																paymentEnum={PaymentClass.SuspendFolio}
																tempState={tempState}
																reducerState={state.folioSearchField}
																label={'Search Suspend Folio'}
																defaultListField={{
																	defaultField: defaultFolio,
																	paymentEnum: PaymentClass.SuspendFolio,
																	data: 'GuestName',
																	type: 'RoomNo',
																	balance: 'CreditBalance',
																}}
																listField={{
																	filterCondition: 'GuestType',
																	fieldKey: ['SuspendFolio'],
																	arg: 'RegistrationID',
																	filteredList: filteredList,
																	setSelectedListItem: setSelectedFolio,
																	selectedListItem: selectedFolio,
																	data: 'GuestName',
																	secondaryData: 'ReferenceID',
																	type: 'RoomNo',
																	balance: 'CreditBalance',
																	paymentEnum: PaymentClass.SuspendFolio,
																	register: register,
																	setValue: setValue,
																	defaultPayment: defaultPayment,
																}}
																selectedField={selectedFolio}
																defaultField={defaultFolio}
																selectedOrder={selectedOrder}
																setSelectedField={setSelectedFolio}
																total={watch(`${defaultPayment}.amountPayment`)}
																onChange={e => {
																	handleSearch(`"${e?.target?.value}"`, [
																		`GuestName`,
																		`RoomNo`,
																	]);
																	if (filteredList?.length === 1) {
																		setSelectedFolio(filteredList[0]);
																	}
																	setTempState(e?.target?.value);
																}}
																defaultValue={
																	selectedOrder?.patronAccountID
																		? `${
																				getMenuXInhouseList?.data?.MenuXInhouseList?.filter(
																					x =>
																						x?.RegistrationID ===
																							selectedOrder?.patronAccountID &&
																						x?.GuestType === 'SuspendFolio',
																				)[0]?.GuestName
																			}`
																		: null
																}
															/>
														)}

													{!MenuXDebtorListLoading &&
														filterCond?.debtor &&
														v?.paymentClass == PaymentClass.Debtor &&
														watch(`${defaultPayment}.selected`) && (
															<SearchField
																data={v?.paymentClass}
																paymentEnum={PaymentClass.Debtor}
																tempState={tempState}
																reducerState={state?.debtorSearchField}
																label={'Search Hotel Debtor'}
																defaultListField={{
																	defaultField: defaultDebtor,
																	paymentEnum: PaymentClass.Debtor,
																	balance: 'CreditBalance',
																	data: 'GuestName',
																	type: 'GuestType',
																}}
																listField={{
																	filterCondition: 'GuestStatus',
																	fieldKey: ['DEBTOR'],
																	arg: 'RegistrationID',
																	filteredList: filteredList,
																	setSelectedListItem: setSelectedDebtor,
																	selectedListItem: selectedDebtor,
																	balance: 'CreditBalance',
																	data: 'GuestName',
																	type: 'GuestType',
																	paymentEnum: PaymentClass.Debtor,
																	register: register,
																	setValue: setValue,
																	defaultPayment: defaultPayment,
																}}
																selectedField={selectedDebtor}
																defaultField={defaultDebtor}
																selectedOrder={selectedOrder}
																setSelectedField={setSelectedDebtor}
																total={watch(`${defaultPayment}.amountPayment`)}
																onChange={e => {
																	handleSearch(`'"${e?.target?.value}"`, [
																		`GuestType`,
																		`GuestName`,
																	]);
																	if (filteredList?.length === 1) {
																		setSelectedDebtor(filteredList[0]);
																	}
																	setTempState(e?.target?.value);
																}}
																defaultValue={
																	selectedOrder?.registrationID
																		? getMenuXDebtorList?.data?.MenuXDebtorList?.filter(
																				x =>
																					x?.RegistrationID ===
																					selectedOrder?.registrationID,
																			)[0]?.GuestName
																		: null
																}
															/>
														)}

													{!loadingOfficer &&
														filterCond?.officer &&
														v?.paymentClass == PaymentClass.Officer &&
														watch(`${defaultPayment}.selected`) && (
															<SearchField
																data={v?.paymentClass}
																paymentEnum={PaymentClass.Officer}
																tempState={tempState}
																reducerState={state?.officerSearchField}
																label={'Search Officer List'}
																defaultListField={{
																	defaultField: defaultOfficer,
																	paymentEnum: PaymentClass.Officer,
																	data: 'name',
																	type: 'designation',
																	balance: 'mobileNo',
																}}
																listField={{
																	fieldKey: ['OFFICER'],
																	arg: 'ID',
																	filteredList: filteredList,
																	setSelectedListItem: setSelectedOfficer,
																	selectedListItem: selectedOfficer,
																	balance: 'mobileNo',
																	data: 'name',
																	type: 'designation',
																	paymentEnum: PaymentClass.Officer,
																	register: register,
																	setValue: setValue,
																	defaultPayment: defaultPayment,
																}}
																selectedField={selectedOfficer}
																defaultField={defaultOfficer}
																selectedOrder={selectedOrder}
																setSelectedField={setSelectedOfficer}
																total={total}
																onChange={e => {
																	handleSearch(`'"${e?.target?.value}"`, [
																		'name',
																		'designation',
																	]);
																	if (filteredList?.length === 1) {
																		setSelectedOfficer(filteredList[0]);
																	}
																	setTempState(e?.target?.value);
																}}
																defaultValue={
																	selectedOrder?.patronAccountID
																		? getOfficer?.filter(
																				x =>
																					x?.ID ===
																					selectedOrder?.patronAccountID,
																			)[0]?.name
																		: null
																}
															/>
														)}

													{!loadingStaff &&
														filterCond?.staff &&
														v?.paymentClass == PaymentClass.Staff &&
														watch(`${defaultPayment}.selected`) && (
															<SearchField
																data={v?.paymentClass}
																paymentEnum={PaymentClass.Staff}
																tempState={tempState}
																reducerState={state?.staffSearchField}
																label={'Search Staff List'}
																defaultListField={{
																	defaultField: defaultStaff,
																	paymentEnum: PaymentClass.Staff,
																	data: 'name',
																	type: 'designation',
																	balance: 'mobileNo',
																}}
																listField={{
																	fieldKey: ['STAFF'],
																	arg: 'ID',
																	filteredList: filteredList,
																	setSelectedListItem: setSelectedStaff,
																	selectedListItem: selectedStaff,
																	balance: 'mobileNo',
																	data: 'name',
																	type: 'designation',
																	paymentEnum: PaymentClass.Staff,
																	register: register,
																	setValue: setValue,
																	defaultPayment: defaultPayment,
																}}
																selectedField={selectedStaff}
																defaultField={defaultStaff}
																selectedOrder={selectedOrder}
																setSelectedField={setSelectedStaff}
																total={total}
																onChange={e => {
																	handleSearch(`'"${e?.target?.value}"`, [
																		'designation',
																		'name',
																	]);
																	if (filteredList?.length === 1) {
																		setSelectedStaff(filteredList[0]);
																	}
																	setTempState(e?.target?.value);
																}}
																defaultValue={
																	selectedOrder?.patronAccountID
																		? getStaff?.filter(
																				x =>
																					x?.ID ===
																					selectedOrder?.patronAccountID,
																			)[0]?.name
																		: null
																}
															/>
													)}

													{watch(`${defaultPayment}.selected`) &&
														watch(`${defaultPayment}.paymentClass`) ===
															PaymentClass.Member ? (
															<Grid container>
																<Grid
																	item
																	xs={1}
																	style={{
																		maxWidth: isDesktop
																			? 'calc(5%)'
																			: 'calc(10%)',
																	}}
																></Grid>
																<Grid item xs={10} style={{ marginLeft: '4px' }}>
																	<Controller
																		render={({ onChange, onBlur, value }) => (
																			<TextField
																				fullWidth
																				autoComplete="off"
																				style={{
																					marginBottom: '0px',
																					marginTop: '0px',
																				}}
																				margin="dense"
																				label="Remarks"
																				onChange={e => {
																					register(`${defaultPayment}.remark`);
																					setValue(
																						`${defaultPayment}.remark`,
																						e.target.value,
																					);
																				}}
																			/>
																		)}
																		name="remark"
																		label={'Remarks'}
																		fullWidth
																		autoComplete="off"
																		multiline={false}
																		margin="dense"
																		ref={register}
																		control={control}
																		className="remark"
																		helperText={
																			state?.radioError &&
																			watch('remark') === undefined
																				? 'Input must not be empty'
																				: null
																		}
																		error={
																			state?.radioError &&
																			watch('remark') === undefined
																		}
																	/>
																</Grid>
															</Grid>
														) : null}
	
													{watch(`${defaultPayment}.selected`) &&
													watch(`${defaultPayment}.paymentClass`) ===
														PaymentClass.Online ? (
														<Grid container>
															<Grid
																item
																xs={1}
																style={{
																	maxWidth: isDesktop
																		? 'calc(5%)'
																		: 'calc(10%)',
																}}
															></Grid>
															<Grid item xs={10} style={{ marginLeft: '4px' }}>
																<Controller
																	render={({ onChange, onBlur, value }) => (
																		<TextField
																			fullWidth
																			autoComplete="off"
																			style={{
																				marginBottom: '0px',
																				marginTop: '0px',
																			}}
																			margin="dense"
																			label="Remarks"
																			onChange={e => {
																				register(`${defaultPayment}.remark`);
																				setValue(
																					`${defaultPayment}.remark`,
																					e.target.value,
																				);
																			}}
																		/>
																	)}
																	name="remark"
																	label={'Remarks'}
																	fullWidth
																	autoComplete="off"
																	multiline={false}
																	margin="dense"
																	ref={register}
																	control={control}
																	className="remark"
																	helperText={
																		state?.radioError &&
																		watch('remark') === undefined
																			? 'Input must not be empty'
																			: null
																	}
																	error={
																		state?.radioError &&
																		watch('remark') === undefined
																	}
																/>
															</Grid>
														</Grid>
													) : null}
	
													{watch(`${defaultPayment}.selected`) &&
													watch(`${defaultPayment}.paymentClass`) ===
														PaymentClass.Skipper ? (
														<Grid container>
															<Grid
																item
																xs={1}
																style={{
																	maxWidth: isDesktop
																		? 'calc(5%)'
																		: 'calc(10%)',
																}}
															></Grid>
															<Grid item xs={10} style={{ marginLeft: '4px' }}>
																<Controller
																	render={({ onChange, onBlur, value }) => (
																		<TextField
																			fullWidth
																			autoComplete="off"
																			style={{
																				marginBottom: '0px',
																				marginTop: '0px',
																			}}
																			margin="dense"
																			label="Remarks"
																			onChange={e => {
																				register(`${defaultPayment}.remark`);
																				setValue(
																					`${defaultPayment}.remark`,
																					e.target.value,
																				);
																			}}
																		/>
																	)}
																	name="remark"
																	label={'Remarks'}
																	fullWidth
																	autoComplete="off"
																	multiline={false}
																	margin="dense"
																	ref={register}
																	control={control}
																	className="remark"
																	helperText={
																		state?.radioError &&
																		watch('remark') === undefined
																			? 'Input must not be empty'
																			: null
																	}
																	error={
																		state?.radioError &&
																		watch('remark') === undefined
																	}
																/>
															</Grid>
														</Grid>
													) : null}
	
													{watch(`${defaultPayment}.selected`) &&
													watch(`${defaultPayment}.paymentClass`) ===
														PaymentClass.Cheque ? (
														<Grid container>
															<Grid
																item
																xs={1}
																style={{
																	maxWidth: isDesktop
																		? 'calc(5%)'
																		: 'calc(10%)',
																}}
															></Grid>
															<Grid item xs={10} style={{ marginLeft: '4px' }}>
																<Controller
																	render={({ onChange, onBlur, value }) => (
																		<TextField
																			fullWidth
																			autoComplete="off"
																			style={{
																				marginBottom: '0px',
																				marginTop: '0px',
																			}}
																			margin="dense"
																			label="Remarks"
																			onChange={e => {
																				register(`${defaultPayment}.remark`);
																				setValue(
																					`${defaultPayment}.remark`,
																					e.target.value,
																				);
																				setChequeremark(e.target.value);
																			}}
																		/>
																	)}
																	name="remark"
																	label={'Remarks'}
																	fullWidth
																	autoComplete="off"
																	multiline={false}
																	margin="dense"
																	ref={register}
																	control={control}
																	className="remark"
																	helperText={
																		`${defaultPayment}.selected` === undefined
																			? 'Input must not be empty'
																			: null
																	}
																	error={
																		`${defaultPayment}.remark` === undefined
																	}
																/>
															</Grid>
														</Grid>
													) : null}
												</>
											</>
										);
									})}
							</RadioGroup>
						</>
					),
					footer: {
						actions: [
							{
								displayText: 'Cancel',
								props: {
									onClick: () => {
										setLocked(false);
										setLocked2(false);
										reset();
										dispatch({ type: 'receivedAmount', payload: 0 });
										dispatch({ type: 'paymentDialog', payload: false });
										setSelectedCredit({});
										setSelectedRoom({});
										setSelectedNonGuest({});
										setSelectedFolio({});
										setSelectedDebtor({});
										setSelectedOfficer({});
										setSelectedCredit({});
										setSelectedStaff({});
										setBankTTremark(null);
										setChequeremark(null);
										setIsTouch(false);
										dispatch({ type: 'radioError', payload: false });
										setCancel(true);
										handleSubmit(data => {
											const { defaultPayment } = data;
											setArray(
												defaultPayment?.filter(x => x?.selected === true),
											);
										})();
										dispatch({ type: 'disablePaymentClass', payload: null });
									},
									variant: 'contained',
									color: 'primary',
								},
							},
							{
								displayText: 'Confirm',
								props: {
									onClick: () => {
										handleSubmit(data => {
											const selectedPayments =
												data?.defaultPayment?.filter(x => x?.selected === true) ?? [];

											setArray(selectedPayments);

											const hasSignature = selectedPayments.some(p =>
												[
													PaymentClass.Room,
													PaymentClass.Member,
													PaymentClass.SuspendFolio,
													PaymentClass.NonGuest,
													PaymentClass.Debtor,
												].includes(p?.paymentClass)
											);

											// Signature payments: sign first, then QR after save if >= 10k
											if (hasSignature && !locked) {
												setSelectedPaymentsign(selectedPayments);
												dispatch({ type: 'signatureDialog', payload: true });
												return;
											}

											// Cash / credit / others: show QR before submit if >= 10k
											const needQR =
												totalT >= 10000 && EinvoiceCheck === true;

											if (needQR) {
												setPendingProceed(true);
												setOpenExitDialog(true);
												return;
											}

											handleConfirmPayment();
										})();
									},
									variant: 'contained',
									color:
										(state?.receivedAmount === 0 && balanceT !== 0) ||
										balanceT > 0 ||
										(array?.filter(x => x?.paymentClass === PaymentClass.BankTt)
											?.length > 0 &&
											(bankTTremark == null || bankTTremark === '')) ||
										(array?.filter(x => x?.paymentClass === PaymentClass.Cheque)
											?.length > 0 &&
											(chequeremark === null || chequeremark === '')) ||
										hasAnyIssue ||
										creditRequiresManualEntry ||
										loading1 ||
										locked ||
										error ||
										terminalDialogState === 'waiting'
											? 'inherit'
											: 'primary',
									disabled:
										(state?.receivedAmount === 0 && balanceT !== 0) ||
										balanceT > 0 ||
										(array?.filter(x => x?.paymentClass === PaymentClass.BankTt)
											?.length > 0 &&
											(bankTTremark === null || bankTTremark === '')) ||
										(array?.filter(x => x?.paymentClass === PaymentClass.Cheque)
											?.length > 0 &&
											(chequeremark === null || chequeremark === '')) ||
										hasAnyIssue ||
										creditRequiresManualEntry ||
										loading1 ||
										locked ||
										error ||
										terminalDialogState === 'waiting',
								},
							},
						],
					},
				}}
			/>

			<LHDNconfirmationDialog
				openExitDialog={openExitDialog}
				setOpenExitDialog={setOpenExitDialog}
				backPath={`/menu/outlet-app/${outletID}/table/grid/${tableID}/order/${state?.selectedOrder?.ID}/bill-settlement/${billID}`}
				handleSubmit={handleSubmit}
				onSubmit={onSubmit}
				selectedCredit={selectedCredit}
				selectedDebtor={selectedDebtor}
				data={array}
				stateItem={state}
				cardType={watch('cardType')}
				cardReference={watch('cardReference')}
				filesLHDN={filesLHDN}
				selectedRoom={selectedRoom}
				selectedNonGuest={selectedNonGuest}
				selectedFolio={selectedFolio}
				remark={watch('remark')}
				selectedOfficer={selectedOfficer}
				selectedStaff={selectedStaff}
				outletID={outletID}
				orderID={orderID}
				setIsBuyerDetails={setIsBuyerDetails}
				dispatch={dispatch}
				isSignature={isSignature()}
				setSelectedPaymentsign={setSelectedPaymentsign}
			/>
			<OfflineTerminalDialog
				state={terminalDialogState}
				errorMessage={terminalErrorMessage}
				onRetry={handleTerminalRetry}
				onInquiry={handleTerminalInquiry}
				onCancel={handleTerminalCancel}
			/>
		</>
	);
};

export const generateRoundingAmount = (
	totalFooter,
	roundingPolicyAmount,
	getRoundingPolicy,
) => {
	const tempCents = totalFooter - Math.floor(totalFooter); // 16.24 - 16.00 = 0.24

	const cents = Math.round((tempCents + Number.EPSILON) * 100) / 100; // 0.24

	const roundingMulti = Math.round(
		(cents * 100) / (roundingPolicyAmount! * 100), // (0.24 * 100) / (0.05 * 100) = 24 / 5 = Math.round(4.8) = 5
	);

	const roundedAmount =
		getRoundingPolicy[0]?.inUse === true
			? Math.floor(totalFooter) + roundingPolicyAmount! * roundingMulti
			: totalFooter; // 16.00 + 0.05 * 5 = 16.

	const roundingAmount = (totalFooter - roundedAmount) * -1; // 16.24 - 16.25 = 0.01

	return Number(roundingAmount.toFixed(2));
};

export const SignatureDialog = (props: any) => {
	const {
		handleSubmit,
		onSubmit,
		state,
		dispatch,
		footerAmount,
		loading1,
		loading2,
		setOpenExitDialog,
		openExitDialog,
		setFilesLHDN,
		filesLHDN,
		outlet,
		selectedDebtor,
		setDefaultDebtor,
		hotelID,
	} = props;

	const {
		files,
		handleUploadChange,
		previewFiles,
		remove: removeFile,
		handleEditUpload,
		setFiles,
	} = useUploadAttachment();

	const [signatureImage, setSignatureImage] = useState(null);

	let sigCanvas = {};

	const clear = () => {
		const signature: any = sigCanvas;
		signature.clear();
	};

	const saveSigCanvas = () => {
		const signature: any = sigCanvas;
		signature.getTrimmedCanvas().toBlob(blob => {
			setSignatureImage(blob);
		});
	};

	const EinvoiceCheck =
		outlet?.company?.isEInvIntegrated === true &&
		new Date(outlet?.businessDate) >=
			new Date(outlet?.company?.eInvStartDate) &&
		new Date(outlet?.businessDate) <= new Date(outlet?.company?.eInvEndDate);

	const [
		loadMenuXDebtorList,
		{
			loading: MenuXDebtorListLoading,
			data: { getMenuXDebtorList } = { getMenuXDebtorList: [] },
		},
	] = useGetMenuXDebtorListLazyQuery({
		fetchPolicy: 'network-only',
		onCompleted: ({ getMenuXDebtorList }) => {
			let defaultOrder = state?.selectedOrder;
			if (defaultOrder?.patronAccountID !== null) {
				setDefaultDebtor(
					getMenuXDebtorList?.data?.MenuXDebtorList?.filter(
						x => x?.RegistrationID === defaultOrder?.registrationID,
					)[0],
				);
			}
		},
	});

	useEffect(() => {
		if (hotelID && state?.outletID) {
			loadMenuXDebtorList({
				variables: {
					hotelID: hotelID,
					outletID: state?.outletID,
				},
			});
		}
	}, [state?.signatureDialog, hotelID, state?.outletID, loadMenuXDebtorList]);

	useEffect(() => {
		if (signatureImage) {
			const debtorIsIndividual =
				selectedDebtor?.IsIndividual === true ||
				getMenuXDebtorList?.data?.MenuXDebtorList?.find(
					x => x?.RegistrationID === selectedDebtor?.RegistrationID,
				)?.IsIndividual === true;

			// After sign: show LHDN QR when total >= 10k (room / suspend / non-guest /
			// company debtor). Skip QR for individual debtor (IsIndividual === true).
			if (
				footerAmount?.total >= 10000 &&
				EinvoiceCheck === true &&
				!debtorIsIndividual
			) {
				setOpenExitDialog(true);
				signatureImage['name'] = 'sigName';
				const newFiles = [signatureImage];
				setFiles([...newFiles]);
				setFilesLHDN(newFiles);
			} else {
				signatureImage['name'] = 'sigName';
				const newFiles = [signatureImage];
				setFiles([...newFiles]);
				handleSubmit(data => onSubmit(data, newFiles))();
			}
		}
	}, [signatureImage]);

	console.log('signatureImage', signatureImage);

	return (
		<>
			<CommonDialog
				fullWidth
				open={state?.signatureDialog}
				onClose={() => dispatch({ type: 'signatureDialog', payload: false })}
				sections={{
					header: {
						dynamic: (
							<>
								<div className="">
									<div className="dialog-dynamic-content">
										<div className="session">
											<div className="flex session">
												<div
													className="title highlight-text flex-space"
													style={{ color: '#ff9800' }}
												>
													Signature
												</div>
												<div className="highlight-text title">{`$${amtStr(
													footerAmount?.total,
												)}`}</div>
											</div>
										</div>
									</div>
									<div className="infoline-content ">
										<div className="xsTitle infoline">
											{/* {`${state?.selectedOrder?.table?.prefix}${state?.selectedOrder?.table?.tableNumber} ${state?.selectedOrder?.docNo}`} */}
										</div>
									</div>
								</div>
							</>
						),
					},
					body: () => (
						<>
							<Grid container style={{ paddingTop: '10px' }}>
								<Grid item xs={8}>
									<span className="sigTitleText"> Sign Here </span>
								</Grid>
								<Grid item xs={4} style={{ textAlign: 'right' }}>
									<span onClick={clear} className="highlight-text">
										{' '}
										Reset
									</span>
								</Grid>
							</Grid>

							<SignatureCanvas
								ref={ref => {
									sigCanvas = ref;
								}}
								penColor="black"
								canvasProps={{
									className: 'sigCanvas',
								}}
							/>
						</>
					),
					footer: {
						actions: [
							{
								displayText: 'Cancel',
								props: {
									onClick: () => {
										dispatch({ type: 'signatureDialog', payload: false });
									},

									variant: 'contained',
									color: 'primary',
								},
							},
							{
								displayText: 'Save',
								props: {
									onClick: () => {
										saveSigCanvas();
										dispatch({ type: 'signatureDialog', payload: false });
										dispatch({ type: 'paymentDialog', payload: false });
									},
									variant: 'contained',
									color: loading1 || loading2 ? 'inherit' : 'primary',
									disabled: loading1 || loading2 ? true : false,
								},
							},
						],
					},
				}}
			/>
		</>
	);
};
